<template>
  <div class="filter-box">
    <a-select v-model="searchKeyWord" :placeholder="placeholder || '您想看哪个国家&amp;地区的品类排行?'"
      @search="handleSearchChange" @change="searchChange" :filter-option="false" showSearch :dropdownMatchSelectWidth="false" style="width: 320px"
    >
      <a-select-option v-for="item in searchList" :key="item.dkey"
        :value="item.dkey"
      >{{item.cname}}</a-select-option>
    </a-select>
    <div class="selected-tag" v-if="multiple">
      <div class="selected-tags" 
        @mouseenter="hoverFlag = i" @mouseleave="hoverFlag = null" 
        v-for="(v,i) in value" :key="v"
      ><span>{{ tagName(v) }}</span><a-icon @click="close(i)" type="close-circle" class="close" v-if="hoverFlag === i"></a-icon></div>
    </div>
    <div class="tag-box">
      <span class="title">常用国家&amp;地区</span>
        <a-checkable-tag key="ALL" v-if="!multiple"
          :checked="value === 'ALL'"
          @change="checked => handleChange('ALL')"
        >全部</a-checkable-tag>
        <template v-for="tag in countryList">
          <a-checkable-tag  :key="tag.dkey"
            :checked="tagChecked(tag.dkey)"
            @change="checked => handleChange(tag.dkey, checked)"
          >
            {{ tag.cname }}
          </a-checkable-tag>
        </template>
    </div>
  </div>  
</template>
<script>
import { getCountry } from '@/api/mediadata'

export default {
	name: 'CountrySelect',
  props: {
    value: [Array, String],
    getData: Function,
    multiple: Boolean,
    placeholder: String
  },
  data() {
    return {
			searchKeyWord: undefined,
			searchList: [],
			countryList: [],
      tagCache: [],
      hoverFlag: null,
    }
  },
	methods: {
    tagName(v) {
      let obj =  this.tagCache.find(val => val.dkey === v)
      return obj?.cname || v
    },
    tagChecked(code) {
      return this.multiple?this.value.indexOf(code) > -1:this.value === code
    },
    searchChange() {
      if(!this.multiple) {
        this.$emit('input', this.searchKeyWord)
      } else if(this.value.indexOf(this.searchKeyWord) === -1) {
        if(this.value.length >= 6) return;
        this.$emit('input', [...this.value, this.searchKeyWord])
      }
			this.getData()
		},
		handleSearchChange(searchName) {
      getCountry({
				searchName
			}).then(res => {
				this.searchList = res.data || [];
        this.tagCache = this.tagCache.concat(this.searchList)
			});  
		},
    handleChange (tag, checked) {
      if(!this.multiple) {
        this.$emit('input', tag)
      } else {
        if(this.value.length >= 6) return;
        if(this.value.indexOf(tag) === -1) {
          this.$emit('input', [...this.value, tag])
        } else {
          this.$emit('input', this.value.filter(v => v !== tag))
        }
      }
			this.searchKeyWord = undefined
			this.getData()
		},
		// 获取国家
		getCountry() {
			getCountry({
				commonlyUsedFlag: 1
      }).then((res) => {
        this.countryList = res.data || []
        this.tagCache = this.tagCache.concat(this.countryList)
      })
		},
    addCache(data) {
      this.tagCache = this.tagCache.concat(data || [])
    },
    close(i) {
      let arr = JSON.parse(JSON.stringify(this.value))
      arr.splice(i, 1)
      this.$emit('input', arr)
			this.getData()
    }
  },
  mounted() {
		this.getCountry()
  }
}
</script>
<style scoped lang="less">
.selected-tag {
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
  .selected-tags {
    vertical-align: middle;
    height: 22px;
    background: #c7eacc;
    border-radius: 4px 4px 4px 4px;
    display: inline-block;
    margin-right: 4px;
    text-align: center;
    padding: 0 8px;
    line-height: 22px;
    font-size: 12px;
    font-weight: 400;
    color: #0d8417;
    position: relative;
    white-space: nowrap;
    text-overflow:ellipsis;
    overflow:hidden;
    max-width: calc(100% - 4px);
    .close {
      background: #fff;
      font-size: 14px;
      position: absolute;
      top: 4px;
      right: 4px;
      border-radius: 50%;
      // color: #fff;
      cursor: pointer;
    }
  }
}
</style>